export function quicklinkFilter() {
  let tabs = document.querySelectorAll('.js-tab');

  tabs.forEach((tab) => {
    let quicklinks = tab.querySelectorAll('.js-content');
    quicklinks.forEach(element => {
      element.addEventListener('click', () => {
        quicklinks.forEach(el => {
          el.classList.remove('active');
        });

        if (element instanceof HTMLElement) {
          element.classList.add('active');
        }
      });
      element.addEventListener('keypress', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          (event.target as HTMLElement).click();
        }
      });
    });
  });

  let allSlider = document.querySelectorAll('.js-activeSlider');
  let allTabs = document.querySelectorAll('.js-content');
  let allLinksMobile;
  allSlider.forEach((element) => {
    if (element.classList.contains('swiper-slide-active')) {
      allLinksMobile = element.querySelectorAll('.js-activeLinks');
      allLinksMobile.forEach((link) => {
        link.setAttribute('tabindex', '0');
      });
    } else {
      allLinksMobile = element.querySelectorAll('.js-activeLinks');
      allLinksMobile.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }
    const setMobileTabindex = () => {
      if (element.classList.contains('swiper-slide-active')) {
        allLinksMobile = element.querySelectorAll('.js-activeLinks');
        allLinksMobile.forEach((link) => {
          link.setAttribute('tabindex', '0');
        });
      } else {
        allLinksMobile = element.querySelectorAll('.js-activeLinks');
        allLinksMobile.forEach((link) => {
          link.setAttribute('tabindex', '-1');
        });
      }
    };

    setMobileTabindex();

    const observer = new MutationObserver(setMobileTabindex);
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  allTabs.forEach((tab) => {
    if (tab.classList.contains('active')) {
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('aria-expanded', 'true');
    } else {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('aria-expanded', 'false');
    }
    const setTabindex = () => {
      if (tab.classList.contains('active')) {
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('aria-expanded', 'true');
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('aria-expanded', 'false');
      }
    };

    setTabindex();

    const observerTab = new MutationObserver(setTabindex);
    observerTab.observe(tab, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });
}
